export const dAppName = 'Dragons Arena NFT';
export const contractAddress = 'erd1qqqqqqqqqqqqqpgqpj4qgdkmgpgn8f9s7jcun9rnk3zkw89estes2kymrm'; // Dragons Arena Contract
export const dragonsCollection = 'DRG-875e1a'; // Dragons Arena NFT
export const eggCollection = 'EGG-6ee076'; // Dragons Arena EGGS

//Where to send the egg to hatch
export const hatchWallet = '000000000000000005000caa0436db405133a4b0f4b1c99473b445671cb982f3'; // Dragons Arena Contract

export const explorerAddress = 'https://explorer.elrond.com/';